module.exports = __webpack_public_path__ + "static/media/clean_img.7f212b0a.svg";